import { actions, reducer } from './reducer';
import * as saga from './saga';
import * as selectors from './selectors';

export const avenModel = { actions, reducer, selectors, saga };
